import { render } from "./mat-input.vue?vue&type=template&id=24380f27&scoped=true"
import script from "./mat-input.vue?vue&type=script&lang=js"
export * from "./mat-input.vue?vue&type=script&lang=js"

import "./mat-input.vue?vue&type=style&index=0&id=24380f27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24380f27"]])

export default __exports__